export const GET_DOCTOR_REQ = "GET_DOCTOR_REQ";
export const GET_DOCTOR_SUCC = "GET_DOCTOR_SUCC";
export const GET_DOCTOR_FAIL = "GET_DOCTOR_FAIL";
export const EDIT_DOCTOR_SUCC = "EDIT_DOCTOR_SUCC";
export const DEL_DOCTOR_SUCC = "DEL_DOCTOR_SUCC"
export const ADD_DOCTOR_SUCC = "ADD_DOCTOR_SUCC"

export const PATIENT_REQ = "PATIENT_REQ";
export const PATIENT_SUCC = "PATIENT_SUCC";
export const PATIENT_FAIL = "PATIENT_FAIL";
export const PATIENT_ADD = "PATIENT_ADD";
export const PATIENT_DEL = "PATIENT_DEL";
